import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiUpgradeStatusType } from '../upgrade-status-type';
import { FranchiseIntranetUpgradeModel } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { UserService } from '@fi-app/user/user.service';

@Component({
    selector: 'fi-franchise-intranet-upgrade-view',
    templateUrl: './franchise-intranet-upgrade-view.component.html',
    styleUrls: ['./franchise-intranet-upgrade-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-franchise-intranet-upgrade-view' },
    standalone: false,
})
export class FranchiseIntranetUpgradeViewComponent implements OnInit {
    @Input('franchiseIntranetUpgrade') FranchiseIntranetUpgrade: FranchiseIntranetUpgradeModel;
    HasEditAccess = false;
    FiStateNames = FiStateNames;
    EditTabs: EditTabsModel;

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        this.HasEditAccess =
            this.stateAccessCheckService.isStateAllowedForCurrentUser('Module.CustomFranchiseIntranetUpgrade.Edit') &&
            this.FranchiseIntranetUpgrade.UpgradeStatusType === FiUpgradeStatusType.Upcoming;

        this.statisticService.Visit(
            ModuleType.CustomFranchiseIntranetUpgrade,
            ObjectTypes.CustomFranchiseIntranetUpgrade,
            this.FranchiseIntranetUpgrade.Id,
        );
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.appTextService.get('upgrade.upgrades'), this.appTextService.get('back'));
    }

    editUpgrade() {
        this.stateService.go(FiStateNames.Upgrade.Edit, { Id: this.FranchiseIntranetUpgrade.Id });
    }

    getVersionTypeName(): string {
        return this.FranchiseIntranetUpgrade.getVersionTypeName(this.appTextService);
    }

    getUpgradeStatusTypeText(): string {
        return this.FranchiseIntranetUpgrade.getUpgradeStatusTypeText(this.appTextService);
    }

    openUserProfileDialog(userId: number) {
        this.userService.openUserViewDialog(userId);
    }
}
